"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.table = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var table = {
  tableFontFamily: _font["default"].family,
  tableBorderColor: _color["default"].cloudyBlue300,
  tableRowHoverBackgroundColor: _color["default"].cloudyBlue100,
  tableRowSelectedBackgroundColor: _color["default"].cloudyBlue300,
  tableCellFontSize: _font["default"].sizeSm,
  tableCellLineHeight: _font["default"].lineHeightSm,
  tableCellPadding: "".concat(_spacing["default"].md, " ").concat(_spacing["default"].xs),
  tableCellColor: _color["default"].pickledBluewood800,
  tableCellBackgroundColor: 'unset',
  tableCellHeadFontSize: _font["default"].sizeSm,
  tableCellHeadLineHeight: _font["default"].lineHeightSm,
  tableCellHeadFontWeight: _font["default"].weightAttention,
  tableCellHeadColor: _color["default"].steel700,
  tableCellHeadBackgroundColor: 'unset'
};
exports.table = table;
var _default = table;
exports["default"] = _default;